import React, { useState, useEffect } from 'react';
import { makeStyles, Button, TextField } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import GreenButton from '../../Shared/GreenButton';
import Checkbox from '@material-ui/core/Checkbox';
import { Formik, Form } from 'formik';
import FormikSelectField from 'formik-material-fields/lib/FormikSelectField';
import * as Yup from 'yup';
import FlagstoneTheme from '../../../Config/flagstoneTheme';

export default function EditWorkingHoursDrawer(props) {
    const classes = useStyles();
    const [workstation, setWorkstation] = useState(null)
    const [start, setStart] = useState("00:00")
    const [end, setEnd] = useState("00:00")
    const [days, setDays] = useState([])
    const [noProduction, setNoProduction] = useState(false)

    function workstationChanged(e) {
        setWorkstation(e.target.value)
    }

    function startChanged(e) {
        setStart(e.target.value)
    }

    function endChanged(e) {
        setEnd(e.target.value)
    }

    function saveWorkingHours() {
        let tempWorkingHours = props.workstation.workingHours.slice()
        var i;
        for(i = 0; i < days.length; i++){
            if(noProduction){
                tempWorkingHours.find(x => x.workstation === workstation && x.day === days[i]).start = "00:00"
                tempWorkingHours.find(x => x.workstation === workstation && x.day === days[i]).end = "00:00"

            }
            else{
                tempWorkingHours.find(x => x.workstation === workstation && x.day === days[i]).start = start
                tempWorkingHours.find(x => x.workstation === workstation && x.day === days[i]).end = end
            }
        }

        var y;
        for(y = 0; y < props.order.productionOrders.length; y++){
            if(!props.checkIfOrderDuringWorkingHours(props.order.productionOrders[y].start, props.order.productionOrders[y].end, props.order.productionOrders[y].workstation, tempWorkingHours)){
                return;
            }
        }      

        props.actions.setWorkingHours(tempWorkingHours)
        props.openDrawer(false)
    }

    function noProductionChanged() {
        setNoProduction(!noProduction)
    }

    function dayChanged(day) {
        let tempDays = days.slice()
        if (tempDays.some(x => x === day)) {
            let index = tempDays.indexOf(days.find(x => x === day))
            tempDays.splice(index, 1)
        }
        else {
            tempDays.push(day)
        }

        setDays(tempDays)
    }

    let workstationData = props.workstation.workstations.map(x => { return ({ label: "Production line " + x.id, value: x.id }) })


    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>Edit working hours</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}><CloseIcon></CloseIcon></Button>
                </div>
            </div>
            <div className={classes.body}>
                <Formik
                    initialValues={{}}
                    validationSchema={Yup.object().shape(props.restriction ? {} : {
                        workstation: Yup.string().required('Workstation is required'),
                    })}
                >
                    {({ isValid, touched }) => (
                        <Form autoComplete="off" className={classes.form}>
                            <div className={classes.restrictionInfo}>
                                <div className={classes.label} >Workstation</div>
                                <FormikSelectField name="workstation" className={classes.formikSelectField} onChange={(e) => workstationChanged(e)} options={workstationData} />
                                <div className={classes.hours}>
                                    <div className={classes.from}>
                                        <div className={classes.fromtill}>
                                            Start working shift
                    </div>
                                        <div>
                                            <TextField className={classes.timePicker}
                                                id="outlined-search"
                                                variant="outlined"
                                                type="time"
                                                defaultValue="00:00"
                                                onChange={time => startChanged(time)}
                                                size="small"
                                                disabled={noProduction}

                                            />
                                        </div>
                                    </div>
                                    <div className={classes.till}>
                                        <div className={classes.fromtill}>
                                            End working shift
                    </div>
                                        <div>
                                            <TextField className={classes.timePicker}
                                                type="time"
                                                id="outlined-search"
                                                variant="outlined"
                                                defaultValue="00:00"
                                                size="small"
                                                onChange={time => endChanged(time)}
                                                disabled={noProduction}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.noProduction}>
                                    <div className={classes.day}>
                                        <Checkbox
                                            className={classes.checkBox}
                                            disableRipple
                                            color="default"
                                            checked={noProduction}
                                            onChange={() => noProductionChanged()}
                                            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                            icon={<span className={classes.icon} />}
                                            inputProps={{ 'aria-label': 'decorative checkbox' }}
                                        // {...props}
                                        />
                                        <div className={classes.dayName}>No production</div>
                                    </div>
                                </div>
                                <div className={classes.days}>
                                    <div className={classes.day}>
                                        <Checkbox
                                            className={classes.checkBox}
                                            disableRipple
                                            color="default"
                                            checked={days.some(x => x === 1)}
                                            onChange={() => dayChanged(1)}
                                            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                            icon={<span className={classes.icon} />}
                                            inputProps={{ 'aria-label': 'decorative checkbox' }}
                                        // {...props}
                                        />
                                        <div className={classes.dayName}>Monday</div>
                                    </div>
                                    <div className={classes.day}>
                                        <Checkbox
                                            className={classes.checkBox}
                                            disableRipple
                                            color="default"
                                            onChange={() => dayChanged(2)}
                                            checked={days.some(x => x === 2)}
                                            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                            icon={<span className={classes.icon} />}
                                            inputProps={{ 'aria-label': 'decorative checkbox' }}
                                        // {...props}
                                        />
                                        <div className={classes.dayName}>Tuesday</div>
                                    </div>
                                    <div className={classes.day}>
                                        <Checkbox
                                            className={classes.checkBox}
                                            disableRipple
                                            color="default"
                                            onChange={() => dayChanged(3)}
                                            checked={days.some(x => x === 3)}
                                            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                            icon={<span className={classes.icon} />}
                                            inputProps={{ 'aria-label': 'decorative checkbox' }}
                                        // {...props}
                                        />
                                        <div className={classes.dayName}>Wednesday</div>
                                    </div>
                                    <div className={classes.day}>
                                        <Checkbox
                                            className={classes.checkBox}
                                            disableRipple
                                            color="default"
                                            checked={days.some(x => x === 4)}
                                            onChange={() => dayChanged(4)}
                                            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                            icon={<span className={classes.icon} />}
                                            inputProps={{ 'aria-label': 'decorative checkbox' }}
                                        // {...props}
                                        />
                                        <div className={classes.dayName}>Thursday</div>
                                    </div>
                                    <div className={classes.day}>
                                        <Checkbox
                                            className={classes.checkBox}
                                            disableRipple
                                            color="default"
                                            checked={days.some(x => x === 5)}
                                            onChange={() => dayChanged(5)}
                                            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                            icon={<span className={classes.icon} />}
                                            inputProps={{ 'aria-label': 'decorative checkbox' }}
                                        // {...props}
                                        />
                                        <div className={classes.dayName}>Friday</div>
                                    </div>

                                    <div className={classes.day}>
                                        <Checkbox
                                            className={classes.checkBox}
                                            disableRipple
                                            color="default"
                                            checked={days.some(x => x === 6)}
                                            onChange={() => dayChanged(6)}
                                            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                            icon={<span className={classes.icon} />}
                                            inputProps={{ 'aria-label': 'decorative checkbox' }}
                                        // {...props}
                                        />
                                        <div className={classes.dayName}>Saturday</div>
                                    </div>

                                    <div className={classes.day}>
                                        <Checkbox
                                            className={classes.checkBox}
                                            disableRipple
                                            color="default"
                                            checked={days.some(x => x === 0)}
                                            onChange={() => dayChanged(0)}
                                            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                            icon={<span className={classes.icon} />}
                                            inputProps={{ 'aria-label': 'decorative checkbox' }}
                                        // {...props}
                                        />
                                        <div className={classes.dayName}>Sunday</div>
                                    </div>

                                </div>
                            </div>
                            <div className={classes.saveButton}>
                                <GreenButton disabled={(Object.entries(touched).length === 0) || days.length === 0 || !isValid || (start > end && !noProduction) || (start === end && !noProduction)} text={"SAVE WORKING HOURS"} onClick={saveWorkingHours}></GreenButton>
                            </div>
                        </Form>
                    )}
                </Formik>




            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "5px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    drawerOpen: {
        width: "25%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        display: "inline-block",
        verticalAlign: "top"
    },
    title: {
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px",
        display: "inline-block"
    },

    header: {
        width: "100%",
        height: "auto",
        marginBottom: "20px"
    },
    formikSelectField: {
        width: "97%",
        height: "40px",
        borderRadius: "5px",
        backgroundColor: "white",
        border: "1px solid #c1c2be",
        paddingLeft: "10px",
        "& .MuiInput-root": {
            height: "40px",
        },
        "& .MuiInput-underline:before": {
            borderBottom: "none !important"
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none !important"
        },
        "& .MuiFormHelperText-root.Mui-error": {
            marginTop: "10px",
            height: "20px",
            backgroundColor: "white",
            display: 'block'
        },
        marginBottom: "10px"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        marginTop: "40px"
    },
    saveButton: {
        width: "100%",
        textAlign: "center",
        marginTop: "30px"
    },
    fromtill: {
        display: 'block',
        color: '#020100',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
    },
    timePicker: {
        borderRadius: "6px",
        backgroundColor: "white",
        "& input": {
            fontSize: "14px !important",
            fontFamily: "Lato, sans-serif !important",
        },
        marginBottom: '10px',
        width: "90%"

    },
    from: {
        width: "50%",
        float: "left",
    },
    till: {
        width: "50%",
        float: "left",
    },
    hours: {
        weight: "100%",
        height: "50px",
        marginBottom: "20px",
        marginTop: "10px"
    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        float: "left"
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
    },
    dayName: {
        float: "left",
        paddingTop: "8px",
        marginLeft: "5px",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
    },
    day: {
        width: "100%",
        height: "40px"
    },
    noProduction: {
        marginBottom: "20px",
        marginTop: "10px"
    }


}));